export default __webpack_public_path__ + "static/char-s-52-zh-Hans-11fb596a9791dfb1c6c0e30a0db7ffd8.webp";